<div class="qr-code-wrapper">
  <h1 mat-dialog-title>{{'QrCode.Title' | translate}}</h1>
  <div mat-dialog-content class="text-center">
    <div>
      {{'QrCode.Text' | translate}}
    </div>
    <qr-code [value]="this.qrCodeValue" size="300" errorCorrectionLevel="M"></qr-code>

  </div>
</div>